(() => {
  const normalize = (value) =>
    value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const fuzzyMatch = (query, text) => {
    if (!query) return true;
    if (text.includes(query)) return true;

    const words = query.split(/\s+/).filter(Boolean);
    if (words.every((word) => text.includes(word))) return true;

    let cursor = 0;
    for (const character of query.replace(/\s/g, '')) {
      cursor = text.indexOf(character, cursor);
      if (cursor === -1) return false;
      cursor += 1;
    }
    return true;
  };

  const init = () => {
    const inputs = [...document.querySelectorAll('[data-wonsis-product-search]')];
    const grid = document.querySelector('[data-testid="product-grid"]');
    if (!inputs.length || !grid) return;

    const empty = document.createElement('li');
    empty.className = 'wonsis-search-empty';
    empty.innerHTML = '<span class="wonsis-search-empty__icon" aria-hidden="true">✨</span><strong>No products found.</strong><span>Try another keyword or clear your search.</span>';
    empty.hidden = true;
    grid.append(empty);

    const filter = (rawQuery, source) => {
      const query = normalize(rawQuery);
      const cards = [...grid.querySelectorAll('.product-grid__item')];
      let visible = 0;

      for (const card of cards) {
        const searchable = normalize(
          `${card.dataset.productTitle || ''} ${card.dataset.productType || ''} ${card.dataset.productVendor || ''}`
        );
        const matched = fuzzyMatch(query, searchable);
        card.hidden = !matched;
        if (matched) visible += 1;
      }

      empty.hidden = visible !== 0;
      for (const input of inputs) {
        if (input !== source) input.value = rawQuery;
        const tools = input.closest('[data-wonsis-collection-tools]');
        const clear = tools?.querySelector('[data-wonsis-search-clear]');
        const status = tools?.querySelector('[data-wonsis-search-status]');
        if (clear) clear.hidden = !query;
        if (status) status.textContent = query ? `${visible} product${visible === 1 ? '' : 's'} found` : '';
      }
    };

    for (const input of inputs) {
      input.addEventListener('input', () => filter(input.value, input));
      input.form?.addEventListener('submit', (event) => {
        if (input.value.trim()) return;
        event.preventDefault();
      });
      input
        .closest('[data-wonsis-collection-tools]')
        ?.querySelector('[data-wonsis-search-clear]')
        ?.addEventListener('click', () => {
          input.value = '';
          filter('', input);
          input.focus();
        });
    }

    new MutationObserver(() => {
      const active = inputs.find((input) => input.value.trim());
      if (active) filter(active.value, active);
    }).observe(grid, { childList: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
